import React, { Component } from "react"
import { Row, Col, Button } from 'react-bootstrap'
import { PropTypes } from "prop-types"
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setUserRole } from "../../redux/actions/action_user"
import ContentWrapper from '../../components/layout/ContentWrapper'
import { URL } from '../../config'
import userManager from '../../userManager'
import { checkRole } from '../../utils/functions'
import { getRequest } from '../../utils/functions/httpRequest'
import  { blue, warning, red } from '../../utils/constants'
import Events from './components/events';
import { Messages } from './constants';

const box = { 
	textAlign: 'center',
	minWidth: '245px',
	maxHeight:'80px',
	padding: '5px 10px 25px 10px',
	fontSize:'18px',
}
const boxHeader = {
	height:'32px',
	padding:'0',
	fontWeight:'bold',
}
const boxContent = {
	marginTop:'5px',
}

class EventsView extends Component {
    constructor(props)
    {
			super(props)
			this.state = {
				completedCurrentSeason:0,
				eventsThisWeek:0,
				eventsThisMonth:0,
				overallCurrentSeason:0,					
				eventsThisWeekSummary:0,
				eventsThisMonthSummary:0,
				eventsCompletedSummary:0,
				eventsOverallSeasonSummary:0,							
				displayType:'',
        searchresults:[]
			};
			this.getEventStats = this.getEventStats.bind(this);
			this.applyPermission = this.applyPermission.bind(this);
			this.handleShowCurrentWeekEvents = this.handleShowCurrentWeekEvents.bind(this);
			this.handleShowCurrentMonthEvents = this.handleShowCurrentMonthEvents.bind(this);
			this.handleShowCompletedEvents = this.handleShowCompletedEvents.bind(this);
			this.handleShowOverallSeason = this.handleShowOverallSeason.bind(this);
    }  
	componentDidMount()
	{
		const { oidc }    = this.props
		const _this = this      
		if (oidc.user === null)
		{
			userManager.signinRedirect().then(function() {
				_this.applyPermission()
			})
		}
		else {
			this.getEventStats() ;
		}
	}
	handleShowCurrentWeekEvents(evt) {
		evt.preventDefault();
        const {	eventsThisWeekSummary } = this.state;
		this.setState({ displayType:Messages.CurrentWeek, searchresults: eventsThisWeekSummary });
	}
	handleShowCurrentMonthEvents(evt) {
		evt.preventDefault();
        const {	eventsThisMonthSummary } = this.state;
	//	searchresults = eventsThisMonthSummary;		
		this.setState({ displayType:Messages.CurrentMonth, searchresults: eventsThisMonthSummary });
	}
	handleShowCompletedEvents(evt) {
		evt.preventDefault();
        const {	eventsCompletedSummary } = this.state;
		//searchresults = eventsCompletedSummary;			
		this.setState({ displayType:Messages.Completed, searchresults: eventsCompletedSummary });
	}
	handleShowOverallSeason(evt) {
		evt.preventDefault();
        const {	eventsOverallSeasonSummary } = this.state;
		//searchresults = eventsOverallSeasonSummary;				
		this.setState({ displayType:Messages.OverallSeason, searchresults: eventsOverallSeasonSummary });
	}
	getEventStats() {
		const statsendpoint = '/stats';
		const token = this.props.oidc.user.access_token
		const  eventURL =  `${URL.event}${statsendpoint}`
		const _this = this
		getRequest(eventURL,'json',token).then(function(response){
			const {
				setupNotCompleted,
				pendingApproval,
				upcomingEvents,
				pendingPostEventReport,
				completedCurrentSeason,
				eventsThisWeek,
				eventsThisMonth,
				overallCurrentSeason,				
				eventsThisWeekSummary,
				eventsThisMonthSummary,
				eventsCompletedSummary,
				eventsOverallSeasonSummary
			} = response.data;
			
			_this.setState({
				setupNotCompleted,
				pendingApproval,
				upcomingEvents,
				pendingPostEventReport,
				completedCurrentSeason,
				eventsThisWeek,
				eventsThisMonth,				
				overallCurrentSeason,
				eventsThisWeekSummary,
				eventsThisMonthSummary,
				eventsCompletedSummary,
				eventsOverallSeasonSummary
			})
		})
	}
	applyPermission()
	{
		const { setUserRole } = this.props
		const { user } = this.props.oidc
		const { roleChecked } = this.props.user
		if ((user != null) && (!roleChecked))
		{
			const token = user.access_token
			setUserRole('')
			checkRole(token).then(function(response) {                  
				const roleName = response.data.roleName
				setUserRole(roleName)
			})
		}
	}
    render() {
        const {
					eventsThisWeek,
					eventsThisMonth,
					completedCurrentSeason,
					overallCurrentSeason,
					displayType,
          searchresults
		} = this.state 
        const { oidc } = this.props
        const uservalidated = oidc.user != null
        const showDetails = displayType !== '';
        return (
            uservalidated && (<ContentWrapper>
                <div className="content-heading">View Events</div>
									<Row>
										<Col sm={6} >
											<h5>Click on any of the metrics for more detailed information.</h5>
											<p />
										</Col>
									</Row>    
                <Row style={{ marginTop:'20px' }}>
                    <Col sm={ 3 }  >
                        <Button id='1' style={{ ...box, color:blue }} onClick={this.handleShowCurrentWeekEvents}>
                            <p  style={boxHeader}>{Messages.CurrentWeek}
                            <hr style={{ ...boxContent,border:`2px solid ${blue}` }}/>
                            </p>
                            <span>{eventsThisWeek}</span>
                        </Button>
                    </Col>
                    <Col sm={ 3 }>
                        <Button id='2' style={{ ...box, color:red }} onClick={this.handleShowCurrentMonthEvents}>
                            <p style={boxHeader}>{Messages.CurrentMonth}
                                <hr style={{ ...boxContent,border:`2px solid ${red}` }}/>
                            </p>
                            <span>{eventsThisMonth}</span>
                        </Button>
                    </Col>
                    <Col sm={ 3 }>
                        <Button id='3' style={{ ...box, color:'green' }} onClick={this.handleShowCompletedEvents}>
                            <p style={boxHeader}>{Messages.Completed}
                                <hr style={{ ...boxContent,border:`2px solid green` }}/>
                            </p>
                            <span>{completedCurrentSeason}</span>
                        </Button>
                </Col>
                    <Col sm={ 3 }>
                    <Button id='4' style={{ ...box, color:warning }} onClick={this.handleShowOverallSeason}>
                        <p style={boxHeader}>{Messages.OverallSeason}
                        <hr style={{ ...boxContent,border:`2px solid ${warning}` }}/>
                        </p>
                        <span>{overallCurrentSeason}</span>
                        </Button>
                    </Col>
                </Row> 
                <Row style={{ marginTop:'20px' }}>				
                    <Col sm={12}>
                    {						
						showDetails && (<Events timeline={displayType} searchResults={searchresults} />)						
                    }
                    </Col>
                </Row>
        </ContentWrapper>)
        )
    }
}

EventsView.propTypes = {
	setUserRole: PropTypes.func,
	oidc: PropTypes.object,
	user: PropTypes.object
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setUserRole
    },dispatch)
}

const mapStateToProps = ({  oidc, user }) => {
    return {
        oidc: { ...oidc },
        user: { ...user }
    }
}
 export default connect(mapStateToProps,mapDispatchToProps)(EventsView);




// WEBPACK FOOTER //
// ./src/containers/eventsview/index.js